const colors = require("tailwindcss/colors");

// color mapping for tailwind color classes
module.exports = {
  gray: colors.coolGray,
  primary: "#00A7E1",
  secondary: "#00395D",
  tertiary: "#57B186",
  fourth: "#91D1ED",
  fifth: "#c5e7c2",
  middle: "#789fb7",
  gradientMin: colors.sky[100],
  gradientMax: "#00395D",
  policy0: colors.coolGray[400],
  policy1: colors.emerald[500],
  policy2: colors.emerald[400],
};
